function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 120 120"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#b)",
  d: "M60 120c33.137 0 60-26.863 60-60S93.137 0 60 0 0 26.863 0 60s26.863 60 60 60"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: ".94",
  d: "M55.712 29.956c1.5-3.942 7.077-3.942 8.578 0l4.173 10.958a18.36 18.36 0 0010.624 10.624l10.957 4.173c3.943 1.5 3.943 7.077 0 8.578l-10.957 4.173a18.36 18.36 0 00-10.624 10.624L64.29 90.043c-1.5 3.942-7.077 3.942-8.578 0l-4.173-10.957a18.36 18.36 0 00-10.624-10.624l-10.957-4.173c-3.942-1.5-3.942-7.077 0-8.578l10.957-4.173a18.36 18.36 0 0010.624-10.624z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "b",
  cx: "0",
  cy: "0",
  r: "1",
  gradientTransform: "rotate(125.33 42.18 28.717) scale(99.7702)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9884ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#471cff"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h120v120H0z"
}))));